// extracted by mini-css-extract-plugin
export default {"text":"packageMealInfo-module__text__XDw5H"};